import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import PublicServicesPortal from './pages/public-services-portal';
import CitizenGuides from './pages/citizen-guides';
import ComplaintSubmission from './pages/complaint-submission';
import HomeDashboard from './pages/home-dashboard';
import OrganizationStructure from './pages/organization-structure';
import NewsAndAnnouncements from './pages/news-and-announcements';
import NewsDetail from './pages/news-detail';
import MediaDetail from './pages/media-detail';
import TrackComplaint from './pages/track-complaint';
import AdminDashboard from './pages/admin';
import DistrictInfo from './pages/district-info';
import AppointmentBooking from './pages/appointment-booking';
import AppointmentAdminDashboard from './pages/appointment-admin';
import AppointmentCalendar from './pages/appointment-calendar';
import OnlineBooking from './pages/online-booking';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<HomeDashboard />} />
        <Route path="/public-services-portal" element={<PublicServicesPortal />} />
        <Route path="/complaint-submission" element={<ComplaintSubmission />} />
        <Route path="/track" element={<TrackComplaint />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/home-dashboard" element={<HomeDashboard />} />
        <Route path="/organization-structure" element={<OrganizationStructure />} />
        <Route path="/news-and-announcements" element={<NewsAndAnnouncements />} />
        <Route path="/news-and-announcements/:tab" element={<NewsAndAnnouncements />} />
        <Route path="/news/:id" element={<NewsDetail />} />
        <Route path="/media/:id" element={<MediaDetail />} />
        <Route path="/district-info" element={<DistrictInfo />} />
        <Route path="/citizen-guides" element={<CitizenGuides />} />
        <Route path="/appointment-booking" element={<AppointmentBooking />} />
        <Route path="/appointment-admin" element={<AppointmentAdminDashboard />} />
        <Route path="/appointment-calendar" element={<AppointmentCalendar />} />
        <Route path="/online-booking" element={<OnlineBooking />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
